import { Component, Input, AfterViewInit, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';
import { LayoutService } from '../layout.service';
import { Login } from 'src/app/model/login';
import { Dicionario } from 'src/app/model/dicionario';
import { ApiService } from 'src/app/service/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { is } from 'date-fns/locale';

@Component({
  selector: 'app-layout-sidenav',
  templateUrl: './layout-sidenav.component.html',
  styles: [':host { display: block; }']
})
export class LayoutSidenavComponent implements AfterViewInit {
  @Input() orientation = 'vertical';

  @HostBinding('class.layout-sidenav') hostClassVertical = false;
  @HostBinding('class.layout-sidenav-horizontal') hostClassHorizontal = false;
  @HostBinding('class.flex-grow-0') hostClassFlex = false;

  user: Login;

  translateEmpresa: string = "";
  translateSetor: string = "";

  // allows you to use ENUM Class in template
  Dicionario = Dicionario;
  mostrarServico: boolean;

  constructor(private router: Router, private appService: AppService, private apiService: ApiService,
    private layoutService: LayoutService, private modalService: NgbModal) {
    // Set host classes
    this.hostClassVertical = this.orientation !== 'horizontal';
    this.hostClassHorizontal = !this.hostClassVertical;
    this.hostClassFlex = this.hostClassHorizontal;

    this.apiService.getUser().then((res: Login) => {
      this.user = res;
      this.hasServico()
    });

    this.apiService.translateEmpresa().then((res: string) => {
      this.translateEmpresa = res;
    });

    this.apiService.translateSetor().then((res: string) => {
      this.translateSetor = res;
    });

  }

  async hasServico() {
    this.mostrarServico = await this.apiService.hasServico()
  }

  ngAfterViewInit() {
    // Safari bugfix
    this.layoutService._redrawLayoutSidenav();
  }

  getClasses() {
    let bg = this.appService.layoutSidenavBg;

    if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
      bg = bg
        .replace(' sidenav-dark', '')
        .replace(' sidenav-light', '')
        .replace('-darker', '')
        .replace('-dark', '');
    }

    return `${this.orientation === 'horizontal' ? 'container-p-x ' : ''} bg-${bg}`;
  }

  isActive(url) {
    // by appwork
    return this.router.isActive(url, true);
  }

  isActive2(url, url_2 = null) {
    // by denes
    return this.router.url && (this.router.url.indexOf(url) >= 0 || (url_2 && this.router.url.indexOf(url_2) >= 0));
  }

  isMenuActive(url, isStock = false) {
    if(isStock){
      return this.router.isActive(url, false);
    }
    return this.router.isActive(url, false) && !this.router.isActive('reports/stock', false);
  }

  isMenuOpen(url, isStock = false, isAdvanced = false) {
    if(isStock){
      return this.router.isActive(url, false) && this.orientation !== 'horizontal'
    }
    return this.router.isActive(url, false) && this.orientation !== 'horizontal' && !this.router.isActive('reports/stock', false);
  }

  toggleSidenav() {
    this.layoutService.toggleCollapsed();
  }


  //#region PERMISSOES

  hasDic(dicEnum: any) {
    return this.apiService.hasDic(dicEnum);
  }

  isShowConfiguracoes() {

    return this.hasDic(
      [
        Dicionario.DISPOSITIVO,
        Dicionario.EMPRESA,
        Dicionario.TAG,
        Dicionario.FORNECEDOR,
        Dicionario.TIPO_COMANDO,
        Dicionario.HORARIO,
        Dicionario.LOCAL_DE_ACESSOS,
        Dicionario.MOTIVO,
        Dicionario.PERFIL_DE_ACESSO,
        Dicionario.GRUPO,
        Dicionario.CONFIGURACAO_SISTEMA
      ]);

  }

  isShowRelatorios() {

    return this.hasDic(
      [
        Dicionario.RELATORIO_CADASTRAL,
        Dicionario.RELATORIO_DE_ACESSO
      ]);

  }

  isShowPessoas() {

    return this.hasDic(
      [
        Dicionario.VISITANTE,
        Dicionario.FUNCIONARIO,
        Dicionario.MORADOR,
        Dicionario.ALUNO,
        Dicionario.CONTA_DE_USUARIO,
        Dicionario.CLIENTE
      ]);

  }

  isShowComunicacoes() {

    return this.hasDic(
      [
        Dicionario.AVISO,
        Dicionario.CHAT
      ]);

  }

  isShowImportacao() {

    return this.hasDic(
      [
        Dicionario.IMPORTACAO_FUNCIONARIO
      ]);

  }

  isShowEstoque() {

    return this.hasDic(
      [
        Dicionario.ESTOQUE,
        Dicionario.PRODUTO
      ]);

  }

  //#endregion



}

